import React from 'react';
import { Select, SelectOption } from './Select';

interface TimePickerProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

const generateTimeOptions = (): SelectOption[] => {
  const times: SelectOption[] = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 15) {
      const hour = h.toString().padStart(2, '0');
      const minute = m.toString().padStart(2, '0');
      const timeString = `${hour}:${minute}`;
      times.push({
        label: timeString,
        value: timeString,
      });
    }
  }
  return times;
};

export const TimePicker: React.FC<TimePickerProps> = ({ value, onChange }) => {
  const options = generateTimeOptions();
  
  const defaultOption = options.find(option => option.value === value);

  return (
    <div className="space-y-2">
      <Select
        options={options}
        defaultOption={defaultOption}
        onSelect={(option) => onChange(option.value)}
        variant="default"    
      />
    </div>
  );
};
